import { CopyIcon } from "../../../shared/icons/CopyIcon";
import { EditIcon } from "../../../shared/icons/EditIcon";
import { PlusIcon } from "../../../shared/icons/PlusIcon";
import { ShareIcon } from "../../../shared/icons/ShareIcon";
import { TransferIcon } from "../../../shared/icons/TransferIcon";
import { TrashIcon } from "../../../shared/icons/TrashIcon";
import { TSidebarActionsMenu } from "../types";

export const SIDEBAR_ITEM_ACTIONS: TSidebarActionsMenu = {
  parent: [
    {
      type: "rename",
      title: "Редактировать",
      icon: <EditIcon />,
      options: [],
    },
    {
      type: "create",
      title: "Создайте объект",
      icon: <PlusIcon />,
      options: [],
    },
    {
      type: "share",
      title: "Управление доступом",
      icon: <ShareIcon />,
      supported_services: [
        "ai_agents_spa",
        "ai_agents_extra_app",
        "research",
        "schemas",
        "skills",
        "userfiles",
      ],
    },
    {
      type: "delete",
      title: "Удалить объект",
      icon: <TrashIcon />,
      options: [],
    },
  ],
  child: [
    {
      type: "rename",
      title: "Редактировать",
      icon: <EditIcon />,
      options: [],
    },
    {
      type: "transfer",
      title: "Переместить объект",
      icon: <TransferIcon />,
      options: [],
    },
    {
      type: "copy",
      title: "Копировать объект",
      icon: <CopyIcon />,
      options: [],
      supported_services: [
        "assistants",
        "ai_agents_extra_app",
        "ai_agents_spa",
        "cases",
        "skills",
        "schemas",
      ],
    },
    {
      type: "share",
      title: "Управление доступом",
      icon: <ShareIcon />,
      supported_services: [
        "ai_agents_spa",
        "ai_agents_extra_app",
        "research",
        "schemas",
        "skills",
        "userfiles",
      ],
    },
    {
      type: "delete",
      title: "Удалить объект",
      icon: <TrashIcon />,
      options: [],
    },
  ],
};
